import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExamService {
  api: string = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getRandomQuestions(){
    return this.http.get(`${this.api}questions/random/30`)
  }

  getExamDetails(guid: string) {
    return this.http.get(`${this.api}exams/${guid}`);
  }

  loginUser(body:any){
    return this.http.post(`${this.api}users/`,body);
  }

  getIpAddress() {
    return this.http.get('https://api.db-ip.com/v2/free/self');
  }

  setIpAddress(){
    this.getIpAddress().subscribe((res: any) => {
      return res.ipAddress;
    });
  }

  startSession(body:any){
    return this.http.post(`${this.api}exam/session`,body);
  }

  submitExam(body:any){
    return this.http.post(`${this.api}exam/session/${sessionStorage.getItem('sessionCode')}/answers`,body);
  }

  updateUserStatus(body:any){
    return this.http.put(`${this.api}Aggneexam_UpdateExamResult/`,body);
  }
}
